(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/hooks/use-live-data.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/hooks/use-live-data.js');
"use strict";


const {
  getLiveTableId
} = svs.components.casino.game;
const {
  useGetSocketLiveDataQuery,
  useGetSocketJackpotDataQuery
} = svs.components.casino_react.casinoStore.endpoints.searchApi;
const {
  interpretLiveData
} = svs.components.casino.game;
const hasLiveOrJackpotData = gameModel => {
  const collection = {
    jackpotId: null,
    liveTableId: null,
    clientStartType: gameModel === null || gameModel === void 0 ? void 0 : gameModel.clientStartType,
    shouldSkip: false
  };
  if (!(gameModel !== null && gameModel !== void 0 && gameModel.clientStartType)) {
    collection.shouldSkip = true;
    return collection;
  }
  collection.clientStartType = gameModel.clientStartType.charAt(0).toUpperCase() + gameModel.clientStartType.slice(1).toLowerCase();
  if (gameModel.lobbyType === 'live') {
    collection.liveTableId = gameModel.provider === 'Playtech' ? gameModel.liveTableId : getLiveTableId(gameModel);
  }
  if (gameModel.jackpotId) {
    collection.jackpotId = gameModel.jackpotId;
  }
  return collection;
};
const useLiveData = gameModel => {
  const {
    jackpotId,
    liveTableId,
    clientStartType,
    shouldSkip
  } = hasLiveOrJackpotData(gameModel);
  const {
    data: liveData
  } = useGetSocketLiveDataQuery({
    liveTableId,
    clientStartType,
    provider: gameModel === null || gameModel === void 0 ? void 0 : gameModel.provider
  }, {
    skip: shouldSkip || !liveTableId
  });
  const {
    data: jackpotData
  } = useGetSocketJackpotDataQuery({
    jackpotId,
    clientStartType
  }, {
    skip: shouldSkip || !jackpotId
  });
  return {
    liveData: liveData !== null && liveData !== void 0 && liveData.game ? interpretLiveData(liveData.game) : undefined,
    jackpotData: jackpotData !== null && jackpotData !== void 0 && jackpotData.jackpot ? jackpotData.jackpot : undefined
  };
};
setGlobal('svs.components.casino_react.casino_store.hooks.useLiveData', useLiveData);

 })(window);